import { ResponseType } from 'axios'
import { authorizedEdgeFetch } from 'app/axios/edge'

interface fetchFileProps {
  url: string
  responseType: ResponseType
  contentType: string
}

export const fetchFile = ({ url, responseType, contentType }: fetchFileProps) =>
  authorizedEdgeFetch.get(url, {
    responseType,
    headers: { Accept: contentType },
  })
